// extracted by mini-css-extract-plugin
export default {"tooltip":"CopyToClipBoardButton_tooltip__WLxJR","tooltiptext":"CopyToClipBoardButton_tooltiptext__Wi9sC"};